import React from "react";
import { Row, Col } from "react-bootstrap";
import { Select, TextBox, Table, Button, Checkbox, IconPlus, IconMinus, IconListView, IconTrash, Tooltip, IconInfo, } from "@veneer/core";

export const showMaxCostPerImpressionReview = ({
  t,
  specialConditionType,
  compensationTable
}) => {
  if ( specialConditionType === 1 || specialConditionType === 13 || specialConditionType === 22 || specialConditionType === 23 || specialConditionType === 26 ) {
    return (
      <Row>
        <Col xs="12" md="12">
          <Table
            name="bonus-table-review"
            columns={[
              { id: "minPrint", label: t("bonustable.table1") },
              { id: "maxPrint", label: t("bonustable.table2") },
              { id: "blackCpp", label: t("prices.blackcommprice") },
              { id: "otherCpp", label: t("prices.othercommprice") },
            ]}
            data={compensationTable}
          />
        </Col>
      </Row>
    );
  }

  return null;
};

export const showBonusSpecialTableReview = ({
  t,
  specialConditionType,
  bonusTable
}) => {
  if ( specialConditionType === 2 || specialConditionType === 8 || specialConditionType === 12 || specialConditionType === 15 || specialConditionType === 17 ) {
    return (
      <>
        <Row>
          <Col xs="12" md="12">
            <Table
              name="bonus-table-review"
              columns={[
                { id: "minPrint", label: t("bonustable.table1") },
                { id: "maxPrint", label: t("bonustable.table2") },
                { id: "bonus", label: "Bonus" },
              ]}
              data={bonusTable}
            />
          </Col>
        </Row>
      </>
    );
  }

  return null;
};

export const showCombineClicksReview = ({
  t,
  specialConditionType,
  combineClicksList
}) => {
  if (specialConditionType === 7 || specialConditionType === 8 || specialConditionType === 17) {
    return (
      <Row>
        <Col xs="12" md="12">
          <Table
            name="combine-clicks-review"
            columns={[
              { id: "endUserCombineClicks", label: t("endUserId") },
              { id: "endUserName", label: t("endUser") },
            ]}
            data={combineClicksList}
          />
        </Col>
      </Row>
    );
  }

  return null;
};

export const showTiersUpReview = ({
  t,
  specialConditionType,
  percentage,
  minimumImp
}) => {
  if (specialConditionType === 4 || specialConditionType === 19) {
    return (
      <Row>
        <Col xs="4" md="4">
          <TextBox
            id="tiers-up-review"
            label="Tiers Up %"
            value={percentage}
            disabled
          />
        </Col>
        <Col xs="4" md="4">
          <TextBox
            id="minimum-impressions-review"
            label={t("bonustable.table1")}
            value={minimumImp}
            disabled
          />
        </Col>
      </Row>
    );
  }

  return null;
};

export const showMinumimDiscountReview = ({
  t,
  specialConditionType,
  minumimDiscount
}) => {
  if (specialConditionType === 11) {
    return (
      <Row>
        <Col xs="4" md="4">
          <TextBox
            id="minimum-discount-review"
            label="Minimum Discount %"
            value={minumimDiscount}
            disabled
          />
        </Col>
      </Row>
    );
  }

  return null;
};

export const showBonusLSDiscountReview = ({
  t,
  specialConditionType,
  lowCoverage,
  bonusLSDiscount
}) => {
  if (specialConditionType === 22 || (specialConditionType === 23 && lowCoverage)) {
    return (
      <Row>
        <Col xs="12" md="12">
          <Table
            name="bonus-ls-review"
            columns={[
              { id: "minPrint", label: t("InitialLSMark") },
              { id: "maxPrint", label: t("EndLSMark") },
              { id: "bonus", label: t("bonus") },
            ]}
            data={bonusLSDiscount}
          />
        </Col>
      </Row>
    );
  }

  return null;
};

export const showRunLengthReview = ({
  t,
  specialConditionType,
  segmentSelected,
  minimumImp,
  percentage,
  MinimumPrint,
  series
}) => {
  if (specialConditionType === 21) {
    return (
      <Row>
        <Col xs="4" md="4">
          <TextBox
            id="minimum-print-review"
            label="Minimum Print"
            value={MinimumPrint}
            disabled
          />
        </Col>

        <Col xs="4" md="4">
          <TextBox
            id="minimum-imp-review"
            label={segmentSelected === "L&P" ? t("minimumMetters") + " L&P*" : t("minimumSheets") + " GCP*"}
            value={minimumImp}
            disabled
          />
        </Col>

        <Col xs="4" md="4">
          <TextBox
            id="percentage-review"
            label={series === 3 ? t("bonusPercentageRL") : t("committedPPIRL")}
            value={percentage}
            disabled
          />
        </Col>
      </Row>
    );
  }

  return null;
};

export const showFixedBonusReview = ({
  t,
  specialConditionType,
  percentage,
  minimumImp,
}) => {
  if ( specialConditionType === 3 || specialConditionType === 14 || specialConditionType === 23 || specialConditionType === 25 ) {
    return (
      <Row>
        <Col xs="4" md="4">
          <TextBox
            id="fixed-bonus-review"
            label="Fixed Bonus %"
            value={percentage}
            disabled
          />
        </Col>
        <Col xs="4" md="4">
          <TextBox
            id="minimum-impressions-review"
            label={t("bonustable.table1")}
            value={minimumImp}
            disabled
          />
        </Col>
      </Row>
    );
  }

  return null;
};
